/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for attaching a user_session_issuer to a remote_session_client via the join table.
 */
export type AttachUserSessionIssuerForm = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * The user_session_issuer to attach.
   */
  userSessionIssuerId: string;
};

/** @internal */
export type AttachUserSessionIssuerForm$Outbound = {
  id: string;
  user_session_issuer_id: string;
};

/** @internal */
export const AttachUserSessionIssuerForm$outboundSchema: z.ZodMiniType<
  AttachUserSessionIssuerForm$Outbound,
  AttachUserSessionIssuerForm
> = z.pipe(
  z.object({
    id: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function attachUserSessionIssuerFormToJSON(
  attachUserSessionIssuerForm: AttachUserSessionIssuerForm,
): string {
  return JSON.stringify(
    AttachUserSessionIssuerForm$outboundSchema.parse(
      attachUserSessionIssuerForm,
    ),
  );
}
